
export const applicationsData = [
    {
        id: "head-1",
        title: "ФИО делегатора",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-2",
        title: "Должность делегатора",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-3",
        title: "ФИО делегата",
        width: "150px",
    },
    {
        id: "head-4",
        title: "Должность делегата",
        icon: "",
        width:  "150px",
    },
    {
        id: "head-8",
        title: "Делегированные заявки",
        icon: "",
        width:  "170px",
    },
    {
        id: "head-5",
        title: "Дата начала ",
        icon: "",
        width:"100px",
    },
    {
        id: "head-6",
        title: "Дата окончания ",
        icon: "",
        width:  "100px",
    },
    // {
    //     id: "head-6",
    //     title: "Комментарий",
    //     icon: "",
    //     width: "200px",
    // },
    {
        id: "head-7",
        title: "  ",
        icon: "",
        width: "66px",
    },
];
